import { render, staticRenderFns } from "./createPassword.vue?vue&type=template&id=441ecf68&scoped=true&"
import script from "./createPassword.vue?vue&type=script&lang=js&"
export * from "./createPassword.vue?vue&type=script&lang=js&"
import style0 from "./createPassword.vue?vue&type=style&index=0&id=441ecf68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441ecf68",
  null
  
)

export default component.exports